import {Card} from "../../../../../../../../components/card/card.jsx";
import DashCard from "../../../../../../../../components/dash-card/dash-card.jsx";
import AggressorsType from "./aggressors-type.jsx";
import RelationshipProtected from "./relationship-protected.jsx";
import AggressorsHistory from "./aggressors-history.jsx";

export default function AggressorsCard({ data }) {
    return (
        <Card className="dash-main-card col-span-9 row-span-1 h-full">
            <Card.Header className="border-b-0! bg-transparent!">
                <Card.Title className="bg-transparent text-[#F4FFFF] text-center translate-y-1.5 w-full text-(length:--font-lg)!">
                    Agressores cadastrados
                </Card.Title>
            </Card.Header>
            <Card.Body className="flex-1 min-h-0 flex px-(--dash-pad-md)! pb-(--dash-pad-md)!">
                <DashCard width="100%" height="100%" className="h-full min-h-0">
                    <section className="h-full min-h-0 min-w-0 grid grid-cols-12 gap-(--dash-pad-md)">
                        <AggressorsType data={data} />
                        <RelationshipProtected data={data} />
                        <AggressorsHistory data={data} />
                    </section>
                </DashCard>
            </Card.Body>
        </Card>
    )
}
